module.exports = __webpack_public_path__ + "img/tata_kelola.52d65c50.png";